const initialState = {};

const userViewSelectedAlertReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_ALERT':
                  return action.results;
            case 'RESET_SELECTED_ALERT':
                  return {}
            case 'LOGOUT_USER':
                  return {};
            default:
                  break;
      }
      return state;
};
export default userViewSelectedAlertReducer;